module.exports = __webpack_public_path__ + "fonts/SuisseIntl-Light.65b30ce.woff2";